// Wysyłka zdarzeń niestandardowych do analytics blonie.cloud.
//
// SDK (paczesny-analytics.min.js, ładowane z atrybutem defer w layoucie)
// wystawia globalnie window.paczesny.track(nazwa, props). Do dnia wpięcia
// tego pliku serwis raportował wyłącznie odsłony — zero zdarzeń — więc nie
// dało się odróżnić ruchu od realnych akcji.
//
// Zdarzenia deklarujemy w widokach atrybutami data-*, nie przez ręczne
// addEventListener na konkretnych węzłach. Dzięki temu nasłuch jest jeden,
// wpięty na document, i przeżywa nawigacje Turbo bez re-bindowania.
//
//   data-analytics-event="nazwa"    → klik w element
//   data-analytics-submit="nazwa"   → wysłanie formularza
//   data-analytics-start="nazwa"    → pierwsza interakcja z formularzem
//   data-analytics-location="..."   → opcjonalny props { location: "..." }

const track = (name, props) => {
  if (!name) return
  try {
    window.paczesny?.track?.(name, props)
  } catch {
    // Analityka nigdy nie może wywrócić interakcji użytkownika.
  }
}

// Rozróżnia miejsca, z których poleciało to samo zdarzenie (np. CTA
// w hero i CTA w stopce strony głównej).
const propsOf = (element) => {
  const location = element.dataset.analyticsLocation
  return location ? { location } : undefined
}

document.addEventListener("click", (event) => {
  const tagged = event.target.closest?.("[data-analytics-event]")
  if (tagged) {
    track(tagged.dataset.analyticsEvent, propsOf(tagged))
    return
  }

  // Kliknięcia w adresy mailowe łapiemy bez oznaczania ich w widokach.
  const mail = event.target.closest?.('a[href^="mailto:"]')
  if (mail) track("email_click", propsOf(mail))
})

// Faza przechwytywania: Turbo też słucha "submit" i wywołuje
// preventDefault, więc chcemy zdążyć przed nim.
document.addEventListener(
  "submit",
  (event) => {
    const form = event.target.closest?.("[data-analytics-submit]")
    if (form) track(form.dataset.analyticsSubmit, propsOf(form))
  },
  true
)

// Pierwsze wejście w pole formularza = użytkownik zaczął go wypełniać.
// WeakSet trzyma formularze, dla których zdarzenie już poleciało, żeby
// każde kolejne kliknięcie w pole nie generowało duplikatu.
const started = new WeakSet()

document.addEventListener("focusin", (event) => {
  const form = event.target.closest?.("[data-analytics-start]")
  if (!form || started.has(form)) return
  started.add(form)
  track(form.dataset.analyticsStart, propsOf(form))
})
